module.exports = __webpack_public_path__ + "static/media/brasilia-img.fb5931fd.png";